export const safeFields = new Set(['cursor', 'tokenBalances', 'stakingInfo']);
